import {Injectable} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {ExportationModalComponent} from './exportation-modal.component';

@Injectable()
export class ExportationModalService  {

  constructor(
    protected modalService: BsModalService
  ) {}

  showExportModal(data: {assignmentId?: string[], channelId?: string[], bsModalRef?: BsModalRef}) {
    const bsModalRef = this.modalService.show(ExportationModalComponent, {animated: true, keyboard: true, backdrop: true, ignoreBackdropClick: false });
    data.bsModalRef = bsModalRef;
    bsModalRef.content.data = data;
  }
}






// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/exportation/exportation-modal.service.ts